<template>
    <div class="flex flex-col h-screen lg:flex-row">
        <NavBar class="shrink-0 z-[999]" :headerService="headerService" :navModuleType="NAV_MENU_TYPE.TECH_FMEA" />
        <div class="flex grow overflow-hidden">
            <router-view class="flex-1"></router-view>
        </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { useHeaderService } from '@/composables/use-header-service';
import { controlDeferred } from '@eureka/utils/control';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
const { headerService } = useHeaderService();

async function openEditionUpgradeFirstLogin() {
    const { is_first_login_after_try_end } = await controlDeferred.promise;
    if (is_first_login_after_try_end) {
        import('@eureka/shared/edition-upgrade').then((mod) => {
            mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_RISK, EurekaPackageType.AIR_COMMERCIAL);
        });
    }
}

onMounted(() => {
    openEditionUpgradeFirstLogin()
})
</script>
